<template>
    <span v-if="siloData.user.id !== 0" class="card" :data-state="state">
        <div class="card__mover" :style="`transition-duration: ${loadModule}`">
            <div class="card__container">
                <div v-if="hideClose !== true" class="swipecloser"
                    @touchstart="onTouchStart"
                    @touchmove="onTouchMove"
                    @touchend="onTouchEnd"
                ></div>
                <Page v-if="activator === 'terms'" :siloData="siloData" :appState="appState"
                    :active="activator === 'terms' && state === 'active' ? true : false" type="terms"
                    @processing="setProcessing" @refreshData="refreshData" @close="close()"
                    @updateState="updateState" />
                <Page v-if="activator === 'goals'" :siloData="siloData" :appState="appState"
                    :active="activator === 'goals' && state === 'active' ? true : false" type="goals"
                    @processing="setProcessing" @refreshData="refreshData" @close="close()"
                    @updateState="updateState" />
                <Page v-if="activator === 'checkin'" :siloData="siloData" :appState="appState"
                    :active="activator === 'checkin' && state === 'active' ? true : false" type="checkin"
                    @processing="setProcessing" @refreshData="refreshData" @close="close()"
                    @updateState="updateState" />
            </div>
        </div>
    </span>
</template>

<script>
import Page from '@c/Page.vue'
export default {
    components: {
        Page,
    },
    data() {
        return {
            state: "inactive",
            anims: {
                loadModuleJS: 550,
            },
            startY: 0,
            endY: 0,
            minSwipeDistance: 60 // px, tweak as needed
        }
    },
    computed: {
        loadModule() {
            return `${this.anims.loadModuleJS}ms`;
        }
    },
    props: {
        siloData: Object,
        appState: String,
        activator: String,
        hasChildren: Boolean,
        hideClose: Boolean,
    },
    watch: {
        appState() {
            if (this.appState === this.activator) {
                this.open();
            }
        },
    },
    mounted() {
        this.checkForCardQueryString();
        this.$options.name = `Card ${this.activator}`;

        if (this.appState === this.activator) {
            this.open();
        }
    },
    methods: {
        checkForCardQueryString() {
            let urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('pg') && urlParams.get('pg') === this.activator) {
                setTimeout(() => {
                    this.open();
                }, 250);
            }
        },
        updateUrl(string = "") {
            //console.log('UPDATING URL');
            var url = new URL(window.location);
            if (string !== "") {
                //console.log('STRING IS NOT BLANK');
                url.searchParams.set('pg', this.activator);
            } else {
                //console.log('STRING IS BLANK');
                url.searchParams.delete('pg');
            }

            window.history.pushState({}, '', url);
        },
        open() {
            window.activecard = this;
            this.state = 'active';
            this.$emit('updateState', 'card');
            // Set the url
            this.updateUrl(this.activator);
            // Post the event
            this.postEventViewed();

        },
        close() {
            //console.log('CLOSING CARD');
            this.state = 'inactive';
            // I think I probably need to update the state here
            this.$emit('updateState', 'home');
            // Clear the url
            this.updateUrl();
        },
        soft_close() {
            this.state = 'inactive';
        },
        setProcessing(state) {
            console.log('setting processing (card)');
            this.$emit('processing', state);
        },
        refreshData(onComplete = null) {
            console.log('refreshing data (card)');
            this.$emit('refreshData', onComplete);
        },
        updateState(newState) {
            this.$emit('updateState', newState);
        },
        postEventViewed() {
            console.log('trying to post event for checkin', this.activator);
            if (this.activator === 'checkin') {
                console.log('postiving event for checkin', this.activator);
                let data = {
                    type: 'open',
                    message: 'Viewed Check-in Assessment',
                };
                window.events.postPageView(data);
            }
        },
        onTouchStart(e) {
            this.startY = e.touches[0].clientY
        },
        onTouchMove(e) {
            this.endY = e.touches[0].clientY
        },
        onTouchEnd() {
            const distance = this.endY - this.startY

            if (distance > this.minSwipeDistance) {
                this.close()
            }

            // reset
            this.startY = 0
            this.endY = 0
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.card {
    display: flex;
    position: fixed;
    top: var(--padding-top-card);
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: $z_top;

    >* {
        width: 100%;
        transition-property: all;
        transition-timing-function: $easing_regular;
        transform: translateY(100%);
    }

    &[data-state="active"] {
        pointer-events: inherit;

        >* {
            transform: translateY(0);
        }
    }

    &[data-state="inactive"] {
        pointer-events: none;

        >* {
            transform: translateY(120%);
        }
    }

    &:has([data-slide-style="takeover"]) {
        top: 0 !important;

        // This hides the little overflow shadow, which is incompatible with the takeover style
        .ms__wrap {
            &:before {
                display: none;
            }
        }
        .ms__nav {
            margin-top: rem(60px) !important;
        }
    }
}

.card__container {
    height: 100%;
    transition: all 0.15s;
}
</style>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.card__container {
    height: 100%;
    transition: all 0.15s;
}

.swipecloser {
    width: 100%;
    height: 30px;
    position: absolute;
    inset: 0 0 auto 0;
    padding-top: rem(8px);
    z-index: 3;

    &:before {
        content: "";
        width: 100px;
        height: 5px;
        display: block;
        margin-inline: auto;
        background-color:grey;
        border-radius: 4px;
        opacity: 0.25;
    }
}

.card {
    &:has([data-slide-style="takeover"]) {
        .ms__nav {
            margin-top: rem(60px) !important;
        }
    }
}
</style>